import { Link } from "react-router-dom";
import Seo from "../Components/Seo.jsx";
import PageHeader from "../Components/PageHeader.jsx";
import { EnquiryCta } from "../Components/SiteInfo.jsx";
import { programStages } from "../constants/data.jsx";

const PATH = "/programs/";

const Programs = () => (
  <>
    <Seo path={PATH} />
    <PageHeader
      title="Tamil Learning Levels and Programs"
      breadcrumbs={[
        { label: "Home", href: "/", icon: "bi-house" },
        { label: "Programs and Levels", active: true },
      ]}
    />

    <section className="py-5">
      <div className="container py-lg-4">
        <div className="row">
          <div className="col-lg-9">
            <p className="fs-5 mb-3">
              Our curriculum follows a pathway from Preschool to Year 12, based
              on the NSW school stages your child already knows.
            </p>
            <p className="text-muted mb-3">
              At every stage children practise listening, speaking, reading and
              writing in Tamil, alongside Tamil history, values and cultural
              traditions. Each stage builds on the one before it.
            </p>
            <p className="text-muted mb-0">
              The stages below describe what we teach. Please{" "}
              <Link to="/contact/" className="red-text fw-semibold">contact us</Link>{" "}
              to confirm which levels have classes this year and where your
              child would fit.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section className="py-5" style={{ background: "#f9f9f9" }}>
      <div className="container">
        <h2 className="fw-bold mb-4">Learning stages</h2>
        <div className="row g-4">
          {programStages.map((item) => (
            <div className="col-md-6 col-lg-4" key={item.stage}>
              <div className="card h-100 border rounded-4 border-bottom-left">
                <div className="card-body p-4">
                  <p className="text-uppercase small fw-bold red-text mb-1">{item.stage}</p>
                  <h3 className="fs-5 fw-bold mb-3">{item.years}</h3>
                  <p className="mb-0 text-muted">{item.focus}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="py-5">
      <div className="container">
        <div className="row g-4 g-lg-5">
          <div className="col-lg-6">
            <h2 className="fw-bold mb-3">How we teach</h2>
            <p className="text-muted">
              Our teaching is student-centred, interactive and culturally
              responsive. Lessons are engaging and age-appropriate, and mix
              traditional and modern teaching methods.
            </p>
            <ul className="text-muted">
              <li>Active participation and communication</li>
              <li>Positive reinforcement and confidence building</li>
              <li>Teachers, parents and students working together</li>
            </ul>
          </div>
          <div className="col-lg-6">
            <h2 className="fw-bold mb-3">Beyond the classroom</h2>
            <p className="text-muted">
              Students take part in cultural celebrations, festivals,
              performances and community events. These give them real reasons
              to use their Tamil and share their culture with family and
              friends.
            </p>
            <Link to="/events/" className="green-text fw-semibold text-decoration-none">
              See our upcoming events
              <i className="bi bi-arrow-right ms-1" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>

    <EnquiryCta />
  </>
);

export default Programs;
